import Hotkeys from 'react-hot-keys';
import { motion } from 'framer-motion';

const CustomTemplatePresentModal: React.FC<{
    onClickCreateNew: () => void;
}> = ({ onClickCreateNew }) => {
    return (
        <Hotkeys keyName="esc">
            <motion.div
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                style={{ zIndex: 20 }}
                transition={{ duration: 0.2, ease: 'linear' }}
                className="font-lato select-none"
            >
                <div className="absolute inset-0 bg-darwin-neutral-1000 bg-opacity-50 z-50"></div>
                <div
                    className="modal-content space-y-16"
                    style={{
                        position: 'absolute',
                        width: '400px',
                        background: 'transparent',
                    }}
                >
                    <div className="px-16 py-24 bg-white flex flex-col rounded-12 items-center space-y-12">
                        <div className="flex items-center space-x-16">
                            <span>
                                <svg
                                    className="w-16 h-16 fill-darwin-accent-bright-yellow-800 cursor-pointer"
                                    viewBox="0 0 14 15"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M7 14.75C10.8555 14.75 14 11.6328 14 7.75C14 3.89453 10.8555 0.75 7 0.75C3.11719 0.75 0 3.89453 0 7.75C0 11.6328 3.11719 14.75 7 14.75ZM7 4.25C7.35547 4.25 7.65625 4.55078 7.65625 4.90625V7.96875C7.65625 8.35156 7.35547 8.625 7 8.625C6.61719 8.625 6.34375 8.35156 6.34375 7.96875V4.90625C6.34375 4.55078 6.61719 4.25 7 4.25ZM7.875 10.375C7.875 10.8672 7.46484 11.25 7 11.25C6.50781 11.25 6.125 10.8672 6.125 10.375C6.125 9.91016 6.50781 9.5 7 9.5C7.46484 9.5 7.875 9.91016 7.875 10.375Z"></path>
                                </svg>
                            </span>
                            <span className="font-700 text-18">
                                You have a custom template set by Eka
                            </span>
                        </div>
                        <span className="text-14 px-16 text-darwin-neutral-800 text-center">
                            Do you still want to create a new template? Doing this will remove your
                            current prescription template.
                        </span>
                        <span className="pb-8 text-14 text-darwin-neutral-800">
                            You can reset to current template later if needed.
                        </span>
                        <button
                            onClick={onClickCreateNew}
                            className="flex px-24 py-6 primary-btn btn--small cursor-pointer items-center"
                        >
                            Create new
                        </button>
                    </div>
                </div>
            </motion.div>
        </Hotkeys>
    );
};

export default CustomTemplatePresentModal;
